import { Grid, Typography } from '@mui/material'
import { contactCopy } from '@/content/copy'
import { brand, contact } from '@/content/site'
import { layout } from '@/theme'
import { Section } from '@/components/ui/Section'
import { Eyebrow } from '@/components/ui/Eyebrow'
import { Breadcrumbs } from '@/components/ui/Breadcrumbs'
import { ContactForm } from '@/components/contact/ContactForm'
import { ContactDetails } from '@/components/contact/ContactDetails'
import { MapEmbed } from '@/components/contact/MapEmbed'
import { Seo } from '@/components/seo/Seo'
import { JsonLd } from '@/components/seo/JsonLd'

// LocalBusiness schema — wired to the central contact config. Placeholder fields
// are omitted until real details are provided, so it stays valid and "goes live"
// automatically once contact.ts is filled in.
const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: brand.legalName,
  url: brand.url,
  image: `${brand.url}${brand.logoBadge}`,
  ...(contact.address !== 'Coming Soon' ? { address: contact.address } : {}),
  ...(contact.phoneHref ? { telephone: contact.phoneHref } : {}),
  ...(contact.email.includes('@') ? { email: contact.email } : {}),
}

export function Contact() {
  return (
    <>
      <Seo title="Contact Us" path="/contact" description="Request a quote or send an inquiry to the True Forge team." />
      <JsonLd data={contactSchema} />

      <Section sx={{ pb: 0 }}>
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Contact' }]} />
        <Eyebrow>{contactCopy.eyebrow}</Eyebrow>
        <Typography variant="h1" component="h1" sx={{ maxWidth: 940 }}>
          {contactCopy.title}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mt: 3, maxWidth: layout.contentMaxWidth }}>
          {contactCopy.lede}
        </Typography>
      </Section>

      <Section>
        <Grid container spacing={{ xs: 5, md: 6 }}>
          <Grid size={{ xs: 12, md: 7 }}>
            <ContactForm />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <ContactDetails />
          </Grid>
        </Grid>
      </Section>

      <Section sx={{ pt: 0 }}>
        <MapEmbed />
      </Section>
    </>
  )
}
